import { http } from 'utils'

import {
  VouchersTemplateAPITypes,
  VouchersTemplateAPISchemas,
  ListVouchersDataTypes,
  VouchersAPITypes,
  CampaignComponentsAPISchemas,
  CampaignComponentsAPITypes,
  CampaignsAPISchemas,
  CampaignsAPITypes,
  CampaignCreateFormTypes,
  CampaignCreationTypes,
  CampaignUpdateFormTypes,
  CampaignUpdateTypes,
  VoucherCreateFormTypes,
  VoucherCreationTypes,
  VoucherUpdateFormTypes,
  VoucherUpdateTypes,
  VouchersDataTypes,
} from 'schemas/campaign-voucher-schemas'

import { DATASTATUS } from 'constants/status'

export async function getCampaignComponentsAPI(campaignId?: number): Promise<CampaignComponentsAPITypes> {
  let url = `/marketing-campaigns/components`
  const params = new URLSearchParams()

  if (campaignId != null) {
    params.append('campaignId', String(campaignId))
  }

  url += `?${params.toString()}`

  const response = await http.get<unknown>(url)
  const validatedData = CampaignComponentsAPISchemas.safeParse(
    response.data
  )
  if (!validatedData.success) {
    return {
      data: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}

export async function getCampaignsAPI(): Promise<CampaignsAPITypes> {
  let url = `/marketing-campaigns`
  const params = new URLSearchParams()

  url += `?${params.toString()}`

  const response = await http.get<unknown>(url)
  const validatedData = CampaignsAPISchemas.safeParse(
    response.data
  )
  if (!validatedData.success) {
    return {
      data: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}

export async function postCreateCampaignsAPI({
  campaignName,
  campaignCode,
  externalReference,
  startDate,
  endDate,
  description,
  statusId,
}: CampaignCreateFormTypes): Promise<CampaignCreationTypes> {
  const url = '/marketing-campaigns/create'
  const data = {
    campaignName,
    campaignCode,
    externalReference,
    startDate,
    endDate,
    description,
    statusId,
  }
  const response = await http.post(url, data)
  return response.data
}

export async function patchUpdateCampaignsAPI({
  campaignId,
  campaignName,
  campaignCode,
  externalReference,
  startDate,
  endDate,
  description,
  statusId,
}: CampaignUpdateFormTypes): Promise<CampaignUpdateTypes> {
  const url = '/marketing-campaigns'
  const data = {
    campaignId,
    campaignName,
    campaignCode,
    externalReference,
    startDate,
    endDate,
    description,
    statusId,
  }
  const response = await http.patch(url, data)
  return response.data
}

export async function getVouchersTemplateAPI(): Promise<VouchersTemplateAPITypes> {
  let url = `/vouchers/templates`
  const params = new URLSearchParams()

  url += `?${params.toString()}`

  const response = await http.get<unknown>(url)
  const validatedData = VouchersTemplateAPISchemas.safeParse(
    response.data
  )
  if (!validatedData.success) {
    return {
      data: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}

export async function postGetVouchersAPI({
  voucherId,
  voucherCode,
  voucherName,
  voucherTypeId,
  productSkus,
  startDate,
  pSize,
  pNumber,
}: ListVouchersDataTypes): Promise<VouchersAPITypes> {
  const url = `/vouchers/lookup`
  const data = {
    voucherId,
    voucherCode,
    voucherName,
    voucherTypeId,
    productSkus,
    startDate,
    pSize,
    pNumber,
  }
  const response = await http.post(url, data)
  return response.data
}

export async function postSearchVouchersAPI({
  voucherId = null,
  voucherCode = null,
  voucherName = null,
  voucherTypeId = null,
  productSkus = null,
  startDate = null,
  pSize = null,
  pNumber = null,
}: {
  voucherId?: number | null,
  voucherCode?: string | null,
  voucherName?: string | null,
  productSkus?: string | null,
  voucherTypeId?: number | null,
  startDate?: string | null,
  pSize?: number | null,
  pNumber?: number | null,
}): Promise<VouchersDataTypes[]> {
  const url = '/vouchers/lookup'
  const data = {
    voucherId,
    voucherCode,
    voucherName,
    productSkus,
    voucherTypeId,
    startDate,
    pSize,
    pNumber,
  }
  const response = await http.post<{ data: VouchersDataTypes[] }>(url, data)
  return response.data.data
}

export async function postCreateVouchersAPI({
  voucherTypeId,
  voucherIssuerId,
  voucherValue,
  pluCode,
  voucherName,
  startDate,
  endDate,
  references,
  voucherCount,
  merchants,
  flSecurityCode,
  description,
  imageUrl,
  mcaId,
  offerId,
  offerValue2,
  offerValue3,
  offerTypeId,
  productSkus,
}: VoucherCreateFormTypes): Promise<VoucherCreationTypes> {
  const url = '/vouchers'
  const data = {
    voucherTypeId,
    voucherIssuerId,
    voucherValue,
    pluCode,
    voucherName,
    startDate,
    endDate,
    references,
    voucherCount,
    merchants,
    flSecurityCode,
    description,
    imageUrl,
    mcaId,
    offerId,
    offerValue2,
    offerValue3,
    offerTypeId,
    productSkus,
  }
  const response = await http.post(url, data)
  return response.data
}

export async function putUpdateVouchersAPI({
  voucherId,
  voucherTypeId,
  voucherValue,
  voucherName,
  startDate,
  endDate,
  references,
  description,
  imageUrl,
  offerId,
  offerValue2,
  offerValue3,
  offerTypeId,
  pluCode,
  merchants,
  productSkus,
}: VoucherUpdateFormTypes): Promise<VoucherUpdateTypes> {
  const url = '/vouchers/update'
  const data = {
    voucherId,
    voucherTypeId,
    voucherValue,
    voucherName,
    startDate,
    endDate,
    references,
    description,
    imageUrl,
    offerId,
    offerValue2,
    offerValue3,
    offerTypeId,
    pluCode,
    merchants,
    productSkus,
  }
  const response = await http.put(url, data)
  return response.data
}